import { BadgeCheck } from "lucide-react";
import { Reveal } from "../lib/motion";
import { COMPLIANCE } from "../data";

export default function Compliance() {
  return (
    <section id="compliance" className="bg-[#F8F7F3] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-[720px] mb-14">
          <Reveal><p className="overline text-[#B08D57] mb-6">Compliance</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="section-title font-display text-[#111] mb-6">Built for International Trade</h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-body text-lg text-[#666] leading-relaxed">
              Registered, certified, and documented for seamless cross-border commerce — so every
              shipment clears with confidence.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-[#E7E1D6] border border-[#E7E1D6]">
          {COMPLIANCE.map((c, i) => (
            <Reveal key={c.code} delay={(i % 3) * 0.06} className="bg-white">
              <div className="flex items-start gap-4 p-7 h-full">
                <BadgeCheck size={22} className="text-[#B08D57] shrink-0 mt-0.5" strokeWidth={1.6} />
                <div>
                  <p className="font-head font-bold text-[#111] text-[15px]">{c.code}</p>
                  <p className="font-body text-[13px] text-[#666] mt-1">{c.label}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
